// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { JournalEntryWithReviewState } from '@/accounting/api/types';

/** Reports whether a journal entry has line items and is not yet reviewed. */
export function isPendingReview(entry: JournalEntryWithReviewState): boolean {
  return !entry.reviewed && entry.lineItems.length > 0;
}
